var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m_page" },
    [
      _c("div", { staticClass: "m_category" }, [
        _c("h2", [_vm._v("组件目录")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("cell")
                  }
                }
              },
              [_vm._v("Cell")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("choice")
                  }
                }
              },
              [_vm._v("Choice")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("field")
                  }
                }
              },
              [_vm._v("Field")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("searchbox")
                  }
                }
              },
              [_vm._v("Searchbox")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("segment")
                  }
                }
              },
              [_vm._v("Segment")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("empty")
                  }
                }
              },
              [_vm._v("Empty")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$router.replace("picker")
                  }
                }
              },
              [_vm._v("Picker")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("readme", { staticClass: "m_readme" }),
      _vm._v(" "),
      _c("div", { staticClass: "m_preview" }, [
        !_vm.anchor ? _c("p", [_vm._v("请选择最左列目录的组件")]) : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "cell",
                expression: "anchor === 'cell'"
              }
            ],
            staticClass: "wrap"
          },
          [
            _c("bmui-cell-arrow1", {
              attrs: {
                title: "cell-arrow1",
                content:
                  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt ut magni perferendis rem hic quam, sunt cum, culpa inventore obcaecati at harum nam eaque fugit fuga perspiciatis. Illum, nihil voluptatibus."
              }
            }),
            _vm._v(" "),
            _c("bmui-cell-arrow2", { attrs: { title: "cell-arrow2" } }),
            _vm._v(" "),
            _c("bmui-cell-text", {
              attrs: {
                title: "cell-text",
                content:
                  "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aspernatur aut debitis nihil distinctio dolorum repudiandae laborum aliquid sapiente, totam culpa sint reiciendis modi dolor quasi dolorem iusto atque error qui."
              }
            }),
            _vm._v(" "),
            _c("bmui-cell-paragraph", {
              attrs: {
                title: "cell-paragraph",
                content:
                  "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Suscipit commodi corporis repellendus ipsum aliquid asperiores rerum quos. Aliquam, non nam alias eveniet, voluptate, maxime facere dolor provident rem recusandae excepturi."
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "choice",
                expression: "anchor === 'choice'"
              }
            ],
            staticClass: "wrap"
          },
          [
            _c("bmui-radio", {
              attrs: {
                title: "radio",
                items: [
                  "111",
                  { name: "选项2", value: "222" },
                  { name: "禁用选项", value: "333", disabled: true },
                  "444",
                  "555"
                ]
              },
              model: {
                value: _vm.radioModel,
                callback: function($$v) {
                  _vm.radioModel = $$v
                },
                expression: "radioModel"
              }
            }),
            _vm._v(" "),
            _c("bmui-radio-list", {
              attrs: {
                items: [
                  "radio-list",
                  { name: "选项", value: "222" },
                  "选项很长很长很长很长很长很长很长很长很长很长很长很长很长"
                ]
              },
              model: {
                value: _vm.radioListModel,
                callback: function($$v) {
                  _vm.radioListModel = $$v
                },
                expression: "radioListModel"
              }
            }),
            _vm._v(" "),
            _c("bmui-check-list-left", {
              attrs: {
                items: [
                  "check-list-left",
                  "222",
                  { name: "选项名称", value: "333", disabled: true }
                ]
              },
              model: {
                value: _vm.checkListLeftModel,
                callback: function($$v) {
                  _vm.checkListLeftModel = $$v
                },
                expression: "checkListLeftModel"
              }
            }),
            _vm._v(" "),
            _c("bmui-check-list-right", {
              attrs: {
                items: [
                  "check-list-right",
                  "222",
                  {
                    name:
                      "选项名称超长超长超长超长超长超长超长超长超长超长超长超长超长超长超长超长超长超长",
                    value: "333",
                    disabled: true
                  }
                ]
              },
              model: {
                value: _vm.checkListRightModel,
                callback: function($$v) {
                  _vm.checkListRightModel = $$v
                },
                expression: "checkListRightModel"
              }
            }),
            _vm._v(" "),
            _c("bmui-selector", {
              attrs: { item: "test", checked: _vm.selectorChecked },
              on: { click: _vm.selectorClick }
            }),
            _vm._v(" "),
            _c("bmui-selector", {
              attrs: {
                item: { name: "选项2的名称", value: "222" },
                disabled: true
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "field",
                expression: "anchor === 'field'"
              }
            ],
            staticClass: "wrap"
          },
          [
            _c("bmui-field-arrow1", {
              attrs: { title: "field-arrow1", content: "已选择" }
            }),
            _vm._v(" "),
            _c("bmui-field-arrow2", { attrs: { title: "field-arrow2" } }),
            _vm._v(" "),
            _c("bmui-field-text1", {
              attrs: { title: "field-text1", placeholder: "自定义占位符" },
              model: {
                value: _vm.fieldText1Model,
                callback: function($$v) {
                  _vm.fieldText1Model = $$v
                },
                expression: "fieldText1Model"
              }
            }),
            _vm._v(" "),
            _c("bmui-field-text1", {
              attrs: {
                title: "field-text1-readonly",
                readonly: "",
                placeholder: "自定义占位符"
              },
              model: {
                value: _vm.fieldText1Model,
                callback: function($$v) {
                  _vm.fieldText1Model = $$v
                },
                expression: "fieldText1Model"
              }
            }),
            _vm._v(" "),
            _c("bmui-field-text1", {
              attrs: {
                title: "field-text1-selectable",
                placeholder: "自定义占位符",
                selectable: ""
              },
              model: {
                value: _vm.fieldText1Model,
                callback: function($$v) {
                  _vm.fieldText1Model = $$v
                },
                expression: "fieldText1Model"
              }
            }),
            _vm._v(" "),
            _c(
              "bmui-field-text1",
              {
                attrs: { title: "field-text1-with-slot" },
                model: {
                  value: _vm.fieldText1Model,
                  callback: function($$v) {
                    _vm.fieldText1Model = $$v
                  },
                  expression: "fieldText1Model"
                }
              },
              [_c("div", [_vm._v("i'm a slot")])]
            ),
            _vm._v(" "),
            _c("bmui-field-text2", {
              attrs: { title: "field-text2" },
              model: {
                value: _vm.fieldText2Model,
                callback: function($$v) {
                  _vm.fieldText2Model = $$v
                },
                expression: "fieldText2Model"
              }
            }),
            _vm._v(" "),
            _c("bmui-field-text2", {
              attrs: { title: "field-text2-selectable", selectable: "" },
              model: {
                value: _vm.fieldText2Model,
                callback: function($$v) {
                  _vm.fieldText2Model = $$v
                },
                expression: "fieldText2Model"
              }
            }),
            _vm._v(" "),
            _c("bmui-field-paragraph", {
              attrs: { title: "field-paragraph" },
              model: {
                value: _vm.fieldParagraph,
                callback: function($$v) {
                  _vm.fieldParagraph = $$v
                },
                expression: "fieldParagraph"
              }
            }),
            _vm._v(" "),
            _c("bmui-field-btn", {
              attrs: {
                title: "field-btn",
                btn: "按钮文字",
                status: _vm.fieldBtnStatus
              },
              on: { submit: _vm.fieldBtnSubmit },
              model: {
                value: _vm.fieldBtn,
                callback: function($$v) {
                  _vm.fieldBtn = $$v
                },
                expression: "fieldBtn"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "searchbox",
                expression: "anchor === 'searchbox'"
              }
            ],
            staticClass: "wrap"
          },
          [
            _c("bmui-searchbox", {
              on: {
                submit: function($event) {
                  _vm.searchboxEmpty = true
                }
              },
              model: {
                value: _vm.searchbox,
                callback: function($$v) {
                  _vm.searchbox = $$v
                },
                expression: "searchbox"
              }
            }),
            _vm._v(" "),
            _vm.searchboxEmpty ? _c("bmui-searchbox-empty") : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "segment",
                expression: "anchor === 'segment'"
              }
            ],
            staticClass: "wrap"
          },
          [
            _c("bmui-segment", {
              attrs: {
                items: [
                  { name: "选项1", value: "1", mark: 100 },
                  { name: "选项2", value: "1", mark: 1 },
                  "3",
                  "4"
                ],
                index: 1
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "empty",
                expression: "anchor === 'empty'"
              }
            ],
            staticClass: "wrap"
          },
          [
            _c("bmui-empty", {
              attrs: { title: "空页面", btn: "按钮要监听组件click.native事件" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.anchor === "picker",
                expression: "anchor === 'picker'"
              }
            ],
            ref: "picker",
            staticClass: "wrap"
          },
          [
            _c("button", { on: { click: _vm.pickerOpen } }, [
              _vm._v("点击打开picker")
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07da210c", { render: render, staticRenderFns: staticRenderFns })
  }
}